import { extractHeader, type Header } from './header';

export interface ParsedSvg {
  svg: SVGSVGElement;
  header: Header;
}

/** SVG 文本 → 真实 DOM。失败一律抛错，绝不返回半成品（调用方负责提示用户） */
export function parseSvgText(text: string): ParsedSvg {
  const doc = new DOMParser().parseFromString(text, 'image/svg+xml');
  const root = doc.documentElement;
  if (!root || root.tagName.toLowerCase() === 'parsererror' || doc.querySelector('parsererror')) {
    throw new Error('SVG 解析失败：文件不是合法的 XML/SVG');
  }
  if (root.tagName.toLowerCase() !== 'svg') {
    throw new Error(`根元素不是 <svg>（实际是 <${root.tagName.toLowerCase()}>）`);
  }
  return { svg: root as unknown as SVGSVGElement, header: extractHeader(text) };
}
